<template>
  <v-container>
    <the-dialog-box
      ref="dialogBox"
      :submit="() => {}"
      :submit-btn-text="'Submit'"
      :max-width="1800"
      :max-height="1000"
    >
      <template slot="header">
        <span class="headline">QR Receiving</span>
      </template>
      <template slot="body">
        <v-container
          style="font-size: 1.3em !important;"
          fluid
          class="mt-3"
        >
          <v-row>
            <v-col cols="12" md="6" class="d-flex">
              <v-card outlined class="d-flex flex-column flex-grow-1">
                <v-card-text class="pa-5 d-flex flex-column flex-grow-1">
                  <v-row align="center" no-gutters class="flex-grow-0 flex-shrink-0">
                    <v-col cols="12" sm="6" class="py-3">
                      <div class="text-subtitle-2 text-uppercase grey--text text--darken-1 mb-1 text-center">
                        Inventory Class
                      </div>
                      <div class="text-center">
                        <v-chip
                          class="px-4 py-2 font-weight-bold qr-identification-chip"
                          text-color="white"
                          :color="inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.color : 'white'"
                        >
                          {{ inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.name : '-' }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-3">
                      <div class="text-subtitle-2 text-uppercase grey--text text--darken-1 mb-1 text-center">
                        QR Code
                      </div>
                      <div class="text-h4 font-weight-bold text--primary mb-3 text-center">
                        {{ qrCode }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-divider class="my-3" />
                  <v-row align="center" no-gutters class="flex-sm-nowrap flex-grow-1">
                    <v-col cols="12" sm="6" class="py-3 pr-sm-4 flex-shrink-1">
                      <div class="text-subtitle-2 grey--text text--darken-2 mb-3">
                        Item Image
                      </div>
                      <v-img
                        v-if="inventoryTag && inventoryTag.item && inventoryTag.item.photo && inventoryTag.item.mime_type"
                        :src="convertedPhoto(inventoryTag.item.photo, inventoryTag.item.mime_type)"
                        contain
                        height="160"
                        class="mx-auto"
                      />
                      <v-sheet
                        v-else
                        height="160"
                        color="grey lighten-4"
                        class="rounded d-flex flex-column align-center justify-center"
                      >
                        <v-icon large color="grey">mdi-image-outline</v-icon>
                        <div class="text-caption grey--text text--darken-1 mt-2">
                          No item image
                        </div>
                      </v-sheet>
                    </v-col>
                    <v-divider vertical class="d-none d-sm-flex" />
                    <v-col cols="12" class="d-sm-none">
                      <v-divider />
                    </v-col>
                    <v-col cols="12" sm="6" class="py-3 pl-sm-4 flex-shrink-1">
                      <div class="text-subtitle-2 grey--text text--darken-2 mb-3">
                        Supplier Label
                      </div>
                      <v-sheet
                        height="160"
                        color="grey lighten-4"
                        class="rounded d-flex flex-column align-center justify-center pa-3"
                      >
                        <a
                          v-if="inventoryTag && inventoryTag.supplier_label && inventoryTag.supplier_label_mime_type"
                          class="d-block align-self-stretch"
                          @click="openItemShowImageForm(inventoryTag.supplier_label, inventoryTag.supplier_label_mime_type)"
                        >
                          <v-img
                            :src="convertedPhoto(inventoryTag.supplier_label, inventoryTag.supplier_label_mime_type)"
                            contain
                            width="100%"
                            height="136"
                          />
                        </a>
                        <template v-else>
                          <v-icon color="grey">mdi-label-outline</v-icon>
                          <span class="text-caption grey--text text--darken-1 mt-2">
                            No Supplier Label
                          </span>
                        </template>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title>Inventory Tag Details</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Inventory Item
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.item_full_name : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id !== inventoryClassIdGlass && inventoryTag.item.classes.id !== inventoryClassIdVWDGlass && inventoryTag.item.classes.id !== inventoryClassIdSID && inventoryTag.item.classes.id !== inventoryClassIdPatioDoor && inventoryTag.item.classes.id !== inventoryClassIdEquipment)"
                      cols="12"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Color
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.color_code : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id !== inventoryClassIdGlass && inventoryTag.item.classes.id !== inventoryClassIdVWDGlass && inventoryTag.item.classes.id !== inventoryClassIdPanels && inventoryTag.item.classes.id !== inventoryClassIdSID && inventoryTag.item.classes.id !== inventoryClassIdPatioDoor && inventoryTag.item.classes.id !== inventoryClassIdEquipment)"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Length
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.length_name : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        UOM
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.uom_name : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag != null && inventoryTag.door_size"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Size
                      </h5>
                      <span class="value"> {{ inventoryTag.door_size.name || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag != null && inventoryTag.door_hinge"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Hinge
                      </h5>
                      <span class="value"> {{ inventoryTag.door_hinge.name || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag != null && inventoryTag.door_swing"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Swing
                      </h5>
                      <span class="value"> {{ inventoryTag.door_swing.name || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag != null && inventoryTag.door_lite"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Lite
                      </h5>
                      <span class="value"> {{ inventoryTag.door_lite.name || '-' }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Location
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.location_name : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Shelf
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.inventory_location_name : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.is_painted != null"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Paint
                      </h5>
                      <span class="value"> {{ inventoryTag.is_painted == 1 ? 'Painted' : 'Non-Painted' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Door Height
                      </h5>
                      <span class="value"> {{ inventoryTag.height != null && inventoryTag.height !== '' ? inventoryTag.height : '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Door Width
                      </h5>
                      <span class="value"> {{ inventoryTag.width != null && inventoryTag.width !== '' ? inventoryTag.width : '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.color && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id === inventoryClassIdSID || inventoryTag.item.classes.id === inventoryClassIdPatioDoor)"
                      cols="12"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Int Color
                      </h5>
                      <span class="value"> {{ inventoryTag.color.code || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.ex_color && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id === inventoryClassIdSID || inventoryTag.item.classes.id === inventoryClassIdPatioDoor)"
                      cols="12"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Ext Color
                      </h5>
                      <span class="value"> {{ inventoryTag.ex_color.code || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id === inventoryClassIdGlass || inventoryTag.item.classes.id === inventoryClassIdVWDGlass)"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Vendor Batch#
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.batch_number : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.is_fritted != null && inventoryTag.item && inventoryTag.item.classes && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Fritted
                      </h5>
                      <span class="value"> {{ inventoryTag.is_fritted == 1 ? 'Fritted' : 'Non-Fritted' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.door_screen && inventoryTag.item && inventoryTag.item.classes && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Screen
                      </h5>
                      <span class="value"> {{ inventoryTag.door_screen.name || '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id === inventoryClassIdGlass || inventoryTag.item.classes.id === inventoryClassIdVWDGlass)"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Production Date
                      </h5>
                      <span>{{ (inventoryTag ? inventoryTag.production_date_simple : '') || '-' }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Qty on Hand
                      </h5> <span> {{ inventoryTag && inventoryTag.quantity_on_hand != null && inventoryTag.quantity_on_hand !== '' ? inventoryTag.quantity_on_hand : '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && inventoryTag.item.classes.id !== inventoryClassIdPatioDoor && inventoryTag.item.classes.id !== inventoryClassIdEquipment"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Project
                      </h5> <span> {{ inventoryTag && inventoryTag.project_name ? inventoryTag.project_name : '-' }}</span>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && inventoryTag.item.classes.id == inventoryClassIdSID"
                      cols="12"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <h5 class="h5">
                        Supplier
                      </h5> <span> {{ inventoryTag && inventoryTag.supplier_name ? inventoryTag.supplier_name : '-' }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider class="mx-4" />
                <v-card-title>Receiving</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="quantity"
                        outlined
                        :disabled="submittedSuccessfully"
                        :rules="[(v) => !!v || 'Quantity Received is required']"
                        type="number"
                      >
                        <template slot="label">
                          Quantity Received<RedAsterisk />
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      class="pt-0"
                    >
                      <v-autocomplete
                        v-model="poNumber"
                        outlined
                        :items="inventoryPos"
                        :rules="[(v) => !!v || 'PO# is required']"
                        :disabled="inventoryPoItemId != null"
                      >
                        <template slot="label">
                          PO#<RedAsterisk />
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id === inventoryClassIdGlass || inventoryTag.item.classes.id === inventoryClassIdVWDGlass)"
                      cols="12"
                      sm="6"
                      class="pt-0"
                    >
                      <v-file-input
                        v-model="supplierLabel"
                        outlined
                        accept="image/*"
                        capture="user"
                        label="Supplier Label"
                        item-text="name"
                        item-value="id"
                      >
                        <template slot="label">
                          Supplier Label<RedAsterisk />
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template #actions>
        <v-spacer />
        <v-btn :disabled="!submittedSuccessfully" @click="print" color="secondary">Print</v-btn>
        <v-btn @click="closeDialog">Close</v-btn>
        <v-btn @click="submit" color="primary" :disabled="submittedSuccessfully">Submit</v-btn>
      </template>
    </the-dialog-box>
    <InventoryItemShowImageForm
      ref="itemShowImageForm"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import InventoryItemShowImageForm from '@/components/forms/InventoryItemShowImageForm';

export default {
  components: {
    InventoryItemShowImageForm,
  },
  data: () => ({
    qrCode: '',
    inventoryTag: null,
    supplierLabel: null,
    inventoryPos: [],
    poNumber: '',
    quantity: 0,
    inventoryPoItemId: null,
    inventoryClassIdGlass: 5,
    inventoryClassIdVWDGlass: 7,
    inventoryClassIdPanels: 8,
    inventoryClassIdSID: 9,
    inventoryClassIdEquipment: 13,
    inventoryClassIdPatioDoor: 14,
    inventoryIdSlab: 1100,
    inventoryIdSweep: 1101,
    inventoryIdInsert: 1102,
    data: null,
    submittedSuccessfully: false,
  }),
  computed: {
    ...mapState({
      userId: (state) => state.user.id,
    }),
  },
  created() {
  },
  methods: {

    open(qrCode, data) {
      this.$refs.dialogBox.open();
      this.submittedSuccessfully = false;
      this.supplierLabel = null;
      this.poNumber = data.po_number || '';
      this.quantity = 0;
      this.qrCode = qrCode;
      this.inventoryPoItemId = data.inventory_po_item_id;
      this.data = data;
      Promise.all([
        this.getInventoryTag(),
        this.getInventoryPos(),
      ]).then(() => {
        this.upsertInventoryBlob();
      })
    },

    async upsertInventoryBlob() {
      try {
        const text = window.location.href;
        const name = this.inventoryTag.item?.name || `QR ${this.inventoryTag.inventory_tag}`;
        const res = await this.$api.inventoryBlob.store({ id: this.inventoryTag.inventory_tag, text, name });

        if (!res || res.err) {
          this.$bus?.$emit?.('showError', res?.errDesc || 'Failed to generate QR.');
        }
      } catch (e) {
        console.error('[inventory_blob/upsert] Error:', e);
        this.$bus?.$emit?.('showError', 'Unexpected error while generating QR.');
      }
    },
    async getInventoryTag() {
      if (!this.qrCode) return;

      const submitModel = {
        filters: {
          inventory_tag: this.qrCode,
          is_qty_on_hand_o: 0,
        },
        includes: {
          is_include_item_image: true,
          is_include_supplier_label: true,
        },
      };

      const res = await this.$api.inventoryTag.read(submitModel);
      if (!res || !res.data || !res.data[0]) {
        return;
      }

      const firstIndex = 0;
      this.inventoryTag = res.data[firstIndex];
    },

    async getInventoryPos() {
      const submitModel = {
        filters: {
          inventory_class_id: this.inventoryTag && this.inventoryTag.item && this.inventoryTag.item.classes ? this.inventoryTag.item.classes.id : null,
        },
      };
      const res = await this.$api.inventoryPo.read(submitModel, null, 'read-simple');
      if (!res) {
        return;
      }
      this.inventoryPos = res;
    },

    convertedPhoto(photo, mimeType) {
      if (!photo) return '';
      return `data:${mimeType};base64, ${photo}`;
    },

    async submit() {
      if (!this.inventoryTag) return false;

      this.$bus.$emit('loading');
      const data = new FormData();

      // Qr Code is treated as inv tag for now
      if (this.qrCode) {
        data.append('inventory_tag', this.qrCode);
      }

      if (this.quantity) {
        data.append('quantity_added', this.quantity);
      }

      if (this.userId) {
        data.append('created_by', this.userId);
      }

      if (this.poNumber) {
        data.append('po_number', this.poNumber);
      }

      if (this.supplierLabel) {
        data.append('supplier_label', this.supplierLabel);
      }

      if (this.inventoryPoItemId) {
        data.append('inventory_po_item_id', this.inventoryPoItemId);
      }

      const res = await this.$api.inventoryTag.qrReceiving(data);

      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading-stop');
        return false;
      }

      if (this.poNumber) {
        const submitData = new FormData();

        if (this.data.inventory_po_id) {
          submitData.append('inventory_po_id', this.data.inventory_po_id);
        }

        if (this.data.packaging_slip) {
          submitData.append('packaging_slip', this.data.packaging_slip);
        }

        if (this.data.packaging_slip_img) {
          submitData.append('packaging_slip_img', this.data.packaging_slip_img);
        }

        const resPo = await this.$api.inventoryPoItem.store(submitData, 'receiving');

        if (!resPo) {
          this.$bus.$emit('showError');
          this.$bus.$emit('loading-stop');
          return false;
        }
      }
      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');

      this.submittedSuccessfully = true;
      return true;
    },

    emitSuccess() {
      this.$emit('success');
    },

    closeDialog() {
      if (this.submittedSuccessfully) this.$emit('success');
      this.$refs.dialogBox.close();
    },

    openItemShowImageForm(photo, type, code) {
      this.$refs.itemShowImageForm.openDialog(photo, type, code);
    },

    async print() {
      //TODO review this function
      if (!this.submittedSuccessfully) return;
      try {
        this.$bus.$emit('loading');
        const WEBHOOK_MODULE_ID_CRYSTAL_INV_TAG = 11;
        const webhookData = {
          module_id: WEBHOOK_MODULE_ID_CRYSTAL_INV_TAG,
          inventory_tag_id: Number(this.inventoryTag.inventory_tag),
          quantity: this.quantity,
        };
        const res = await this.$api.webhook.store( webhookData, 'run-download', { responseType: 'blob' });
        if (!res) return this.$bus.$emit('showError', 'Failed to generate PDF');

        const blob = res instanceof Blob ? res : (res.data instanceof Blob ? res.data : new Blob([res], { type: 'application/pdf' }));
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `inventory_tag_${this.inventoryTag.id}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('[reprint] Error:', e);
        this.$bus.$emit('showError', 'Error generating PDF');
      } finally {
        this.$bus.$emit('loading-stop');
      }
    },
  },
};
</script>

<style scoped>
.qr-identification-chip {
  height: auto;
  max-width: 100%;
}

.qr-identification-chip >>> .v-chip__content {
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
}
</style>
